import { describeSpiderProgress, SpiderBoard } from '../components/SpiderBoard.js';
import { useStore } from '../store.js';
import { SoloRoom } from './SoloRoom.js';

/** Spider at the table: the shared patience screen, wearing its board. */
export function SpiderRoom() {
  const view = useStore((s) => s.spider);

  if (!view) {
    return (
      <main className="game">
        <p className="game__loading">Dealing…</p>
      </main>
    );
  }

  return (
    <SoloRoom
      name="Spider"
      phase={view.phase}
      moveNumber={view.moveNumber}
      status={describeSpiderProgress(view)}
      board={<SpiderBoard />}
      stuckTitle="Nothing left to move"
      stuckBody="No card on the table will sit on another and the stock is spent. Eight runs was a lot to ask of that deal."
    />
  );
}
